import {
  ICreateExternalClient,
  ICreateExternalClientResponse,
  IExternalClientsListResponse,
  IGetExternalClientResponse,
  IUpdateExternalClient,
  IUpdateExternalClientResponse,
  IRotateApiKeyResponse,
  IRotateWebhookSecretResponse,
  ITenantOutlet,
} from '../types/raas.types';
import { instance } from './instance';

export interface IRaasApi {
  createExternalClient: (
    payload: ICreateExternalClient,
  ) => Promise<ICreateExternalClientResponse>;
  getAllExternalClients: (params?: {
    page?: number;
    perPage?: number;
    active?: boolean;
  }) => Promise<IExternalClientsListResponse>;
  getExternalClient: (id: number) => Promise<IGetExternalClientResponse>;
  updateExternalClient: (
    id: number,
    payload: IUpdateExternalClient,
  ) => Promise<IUpdateExternalClientResponse>;
  rotateApiKey: (id: number) => Promise<IRotateApiKeyResponse>;
  rotateWebhookSecret: (id: number) => Promise<IRotateWebhookSecretResponse>;
  activateClient: (id: number) => Promise<any>;
  deactivateClient: (id: number) => Promise<any>;
  listClientOutlets: (clientId: number) => Promise<{ data: ITenantOutlet[] }>;
  updateClientOutlet: (
    clientId: number,
    code: string,
    body: { riderCapacity: number },
  ) => Promise<{ data: ITenantOutlet }>;
}

export const raasApi: IRaasApi = {
  createExternalClient: async (payload) => {
    const response = await instance.post(
      '/admin/external-client/create',
      payload,
    );
    return response.data;
  },

  getAllExternalClients: async (params = {}) => {
    const { page = 1, perPage = 20, active } = params;
    const queryParams = new URLSearchParams({
      page: page.toString(),
      perPage: perPage.toString(),
    });

    if (active !== undefined) {
      queryParams.append('active', active.toString());
    }

    const response = await instance.get(
      `/admin/external-client/list?${queryParams.toString()}`,
    );
    return response.data;
  },

  getExternalClient: async (id) => {
    const response = await instance.get(`/admin/external-client/${id}`);
    return response.data;
  },

  updateExternalClient: async (id, payload) => {
    const response = await instance.put(
      `/admin/external-client/${id}`,
      payload,
    );
    return response.data;
  },

  rotateApiKey: async (id) => {
    const response = await instance.post(
      `/admin/external-client/${id}/rotate-api-key`,
    );
    return response.data;
  },

  rotateWebhookSecret: async (id) => {
    const response = await instance.post(
      `/admin/external-client/${id}/rotate-webhook-secret`,
    );
    return response.data;
  },

  activateClient: async (id) => {
    const response = await instance.patch(
      `/admin/external-client/${id}/activate`,
    );
    return response.data;
  },

  deactivateClient: async (id) => {
    const response = await instance.patch(
      `/admin/external-client/${id}/deactivate`,
    );
    return response.data;
  },

  listClientOutlets: async (clientId) => {
    const response = await instance.get(
      `/admin/external-clients/${clientId}/outlets`,
    );
    return response.data;
  },

  updateClientOutlet: async (clientId, code, body) => {
    const response = await instance.patch(
      `/admin/external-clients/${clientId}/outlets/${code}`,
      body,
    );
    return response.data;
  },
};
